import CreatePattern from "./CreatePattern";

export default CreatePattern;
